<header class="navbar navbar-expand-lg fixed-top nga-navbar bg-white">
  <nav class="container-fluid" aria-label="Main navigation">
    <a routerLink="/erajaya" class="navbar-brand mt-3" [attr.alt]="'Home - ' + appInfo.name">
      <img 
        [src]="'./assets/params/images/logo/' + appInfo.logo + '-logo.png'"
        [alt]="appInfo.name + ' Logo'"
      >
    </a>
  </nav>
</header>
